import {observer} from 'mobx-react'
import HELP from '../stores/Help'
import UI from '../stores/UI'
import Arrow from '../svg/Arrow'
import Spinner from '../svg/Spinner'
import Cursor from './Cursor'

class IntroPadding extends React.Component {

  constructor(props) {
    super(props)
  }

  handleClick = e => {
    HELP.scrollToY(window.innerHeight, 1.5)
  }

  render() {

    const css = {
      height: '100%',
      cursor: 'none',
      zIndex: 11
    }

    return (
      <span>
        {UI.showIntroPadding ? (
          <div className={`intro-padder rel ${this.props.className}`} style={css} onClick={this.handleClick}>
            {this.props.children}
            {UI.headerIsScaling && !UI.isTouch ? <Cursor fill={'#000000'} isDown /> : null}
            {UI.isTouch && UI.showIntroPrompt ? (
              <div className="intro-prompt padx4">
                <div style={{ transform: `rotate(-90deg)` }}>
                  {UI.isLoading ? <Spinner fill={'#000000'} /> : <Arrow fill={'#000000'} />}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </span>
    )
  }
}

export default observer(IntroPadding)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/IntroPadding.js